import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Star } from "lucide-react";

export default function TestimonialsPreview({ testimonials }) {
  return (
    <section className="py-24 md:py-32 bg-[#0A0A0A]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center space-y-4 mb-16">
          <div className="flex items-center justify-center gap-3">
            <div className="h-px w-12 bg-[#D4AF37]" />
            <span className="text-[#D4AF37] uppercase tracking-[0.2em] text-sm">Five-Star Reviews</span>
            <div className="h-px w-12 bg-[#D4AF37]" />
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-white">
            What Clients <span className="text-[#D4AF37]">Are Saying</span>
          </h2>
          <div className="flex items-center justify-center gap-2 pt-2">
            {[1, 2, 3, 4, 5].map((n) => (
              <Star key={`review-star-${n}`} className="w-5 h-5 fill-[#D4AF37] text-[#D4AF37]" />
            ))}
            <span className="text-white font-bold ml-2">5.0 on Zillow</span>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="card-dark p-8 space-y-6 animate-fadeInUp relative hover:border-[#D4AF37]/50 transition-colors"
              data-testid={`testimonial-card-${testimonial.id}`}
            >
              <div className="absolute top-6 right-6 text-[#D4AF37] text-6xl font-serif opacity-20">"</div>
              <div className="flex gap-1">
                {[1, 2, 3, 4, 5].map((n) => (
                  <Star key={`t-star-${testimonial.id}-${n}`} className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" />
                ))}
              </div>
              <p className="text-zinc-300 leading-relaxed relative z-10">{testimonial.text}</p>
              <div className="pt-4 border-t border-white/10 flex justify-between items-end">
                <div>
                  <p className="text-white font-semibold">{testimonial.name}</p>
                  <p className="text-[#D4AF37] text-sm">{testimonial.location}</p>
                </div>
                {testimonial.date && (
                  <p className="text-zinc-500 text-xs">{testimonial.date}</p>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/testimonials">
            <Button
              className="bg-transparent border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black rounded-none font-bold uppercase tracking-widest"
              data-testid="view-testimonials-button"
            >
              Read All Reviews
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
